import React from "react";
import "./loading.scss";

const Loading = () => {
  return (
    <div className="loading_wrp">
      <div className="loading_msg">
        <img src={require("../../img/loading.gif")} alt="" />
      </div>
    </div>
  );
};

export default Loading;
